import store from "@/state/store";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../pages/views/login/Login.vue"),
  },
  {
    path: "/",
    name: "dashboard",
    meta: {
      authRequired: false,
    },
    component: () => import("../pages/views/dashboard/Dashboard.vue"),
  },
  {
    path: "/stock-list",
    name: "productSearch",
    component: () => import("../pages/views/product/ProductSearch.vue"),
  },
  {
    path: "/current-list",
    name: "currentList",
    component: () => import("../pages/views/current/CurrentList.vue"),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.RoleGroupId !== '3') {
        next();
      } else {
        next('/404');
      }
    },
  },
  {
    path: "/new-current",
    name: "newCurrent",
    component: () => import("../pages/views/current/NewCurrent.vue"),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.RoleGroupId !== '3') {
        next();
      } else {
        next('/404');
      }
    },
  },
  {
    path: "/cart",
    name: "cart",
    component: () => import("../pages/views/cart/Cart.vue"),
  },
  {
    path: "/cart/checkout",
    name: "cartCheckout",
    component: () => import("../pages/views/cart/Checkout.vue"),
  },
  {
    path: "/order-list",
    name: "orderList",
    component: () => import("../pages/views/order/OrderList.vue"),
  },
  {
    path: "/b2b-order-list",
    name: "b2bOrderList",
    component: () => import("../pages/views/order/B2BOrderList.vue"),
  },
  {
    path: "/pending-order-list",
    name: "waitingOrderList",
    component: () => import("../pages/views/order/WaitingOrderList.vue"),
  },
  {
    path: "/purchase-order-list",
    name: "purchaseOrderList",
    component: () => import("../pages/views/order/PurchaseOrderList.vue"),
  },
  {
    path: "/order-detail",
    name: "orderDetail",
    component: () => import("../pages/views/order/OrderDetail.vue"),
  },
  {
    path: "/management/user-management",
    name: "userManagement",
    component: () => import("../pages/views/management/UserManagement.vue"),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.RoleGroupId === '1' && store.state.auth.user.RoleId === '1') {
        next();
      } else {
        next('/404');
      }
    },
  },
  {
    path: "/management/user-applicants",
    name: "userApplicants",
    component: () => import("../pages/views/management/UserApplicants.vue"),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.RoleGroupId === '1' && store.state.auth.user.RoleId === '1') {
        next();
      } else {
        next('/404');
      }
    },
  },
  {
    path: "/management/settings",
    name: "settings",
    component: () => import("../pages/views/management/Settings.vue"),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.RoleGroupId === '1' && store.state.auth.user.RoleId === '1') {
        next();
      } else {
        next('/404');
      }
    },
  },
  {
    path: "/management/announcement",
    name: "announcements",
    component: () => import("../pages/views/management/Announcements.vue"),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.RoleGroupId === '1') {
        next();
      } else {
        next('/404');
      }
    },
  },
  {
    path: "/management/payment-settings",
    name: "paymentSettings",
    component: () => import("../pages/views/management/PaymentSettings.vue"),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.RoleGroupId === '1' && store.state.auth.user.RoleId === '1') {
        next();
      } else {
        next('/404');
      }
    },
  },
  {
    path: "/management/slider-management",
    name: "sliderSettings",
    component: () => import("../pages/views/management/SliderManagement.vue"),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.RoleGroupId === '1' && store.state.auth.user.RoleId === '1') {
        next();
      } else {
        next('/404');
      }
    },
  },
  {
    path: "/management/payment-methods",
    name: "paymentMethods",
    component: () => import("../pages/views/management/PaymentMethods.vue"),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.RoleGroupId === '1' && store.state.auth.user.RoleId === '1') {
        next();
      } else {
        next('/404');
      }
    },
  },
  {
    path: "/management/basket-categories",
    name: "cartCategories",
    component: () => import("../pages/views/management/BasketCategories.vue"),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.RoleGroupId === '1') {
        next();
      } else {
        next('/404');
      }
    },
  },
  {
    path: "/management/stock-categories",
    name: "stockCategories",
    component: () => import("../pages/views/management/StockCategories.vue"),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.RoleGroupId === '1') {
        next();
      } else {
        next('/404');
      }
    },
  },
  {
    path: "/management/detailed-reports/:type?",
    name: "detailedReport",
    component: () => import("../pages/views/management/DetailedReports.vue"),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.RoleGroupId === '1') {
        next();
      } else {
        next('/404');
      }
    },
  },
  {
    path: "/management/target-management",
    name: "targetManagement",
    component: () => import("../pages/views/management/TargetManagement.vue"),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.RoleGroupId === '1' ) {
        next();
      } else {
        next('/404');
      }
    },
  },
  {
    path: "/management/branch-warehouse-management",
    name: "branchWarehouseManagement",
    component: () => import("../pages/views/management/BranchWarehouseManagement.vue"),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.RoleGroupId === '1' && store.state.auth.user.RoleId === '1') {
        next();
      } else {
        next('/404');
      }
    },
  },
  {
    path: "/management/calendar-categories/:type?",
    name: "calendarCategories",
    component: () => import("../pages/views/management/CalendarCategories.vue"),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.RoleGroupId === '1') {
        next();
      } else {
        next('/404');
      }
    },
  },
  {
    path: "/current-approval-list",
    name: "currentApprovalList",
    component: () => import("../pages/views/current/CurrentApprovalList.vue"),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.RoleGroupId === '1') {
        next();
      } else {
        next('/404');
      }
    },
  },
  {
    path: "/current-open-list",
    name: "currentOpenList",
    component: () => import("../pages/views/current/B2BCurrents.vue"),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.RoleGroupId === '1') {
        next();
      } else {
        next('/404');
      }
    },
  },

  {
    path: "/product-detail/:stockCode",
    name: "productDetail",
    component: () => import("../pages/views/product/ProductDetail.vue"),
  },

  {
    path: "/campaigns",
    name: "campaigns",
    component: () => import("../pages/views/campaign/Campaign.vue"),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.RoleGroupId !== '3') {
        next();
      } else {
        next('/404');
      }
    },
  },

  // {
  //   path: "/offers",
  //   name: "offers",
  //   component: () => import("../pages/views/offer/OfferList.vue"),
  //
  // },

  {
    path: "/unclosed-invoices",
    name: "unclosedInvoices",
    component: () => import("../pages/views/my-account/UnclosedInvoices.vue"),
  },
  {
    path: "/current-actions",
    name: "currentActions",
    component: () => import("../pages/views/my-account/AccountStatements.vue"),
  },
  // {
  //   path: "/calendar",
  //   name: "calendar",
  //   component: () => import("../pages/views/calendar/Calendar"),
  // },
  {
    path: "/collection",
    name: "collection",
    component: () => import("../components/collection/PhysicalCollection"),
  },

  {
    path: "/payment",
    name: "payment",
    component: () => import("../components/collection/PaymentList"),
  },

  {
    path: "/virtual-payment",
    name: "virtualPayment",
    component: () => import("../components/collection/ParamPos"),
  },

  {
    path: "/404",
    name: "404",
    component: require("./views/utility/404").default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: "*",
    redirect: "404",
  },
  {
    path: "/pages/starter",
    name: "Starter",
    meta: { authRequired: true },
    component: () => import("./views/utility/starter"),
  },
  {
    path: "/pages/maintenance",
    name: "Maintenance",
    meta: { authRequired: true },
    component: () => import("./views/utility/maintenance"),
  },
  {
    path: "/pages/coming-soon",
    name: "coming-soon",
    meta: { authRequired: true },
    component: () => import("./views/utility/coming-soon"),
  },
  {
    path: "/pages/timeline",
    name: "Timeline",
    meta: { authRequired: true },
    component: () => import("./views/utility/timeline"),
  },
  {
    path: "/pages/faqs",
    name: "FAQs",
    meta: { authRequired: true },
    component: () => import("./views/utility/faqs"),
  },
  {
    path: "/pages/pricing",
    name: "Pricing",
    meta: { authRequired: true },
    component: () => import("./views/utility/pricing"),
  },
  {
    path: "/pages/404",
    name: "Error-404",
    meta: { authRequired: true },
    component: () => import("./views/utility/404"),
  },
  {
    path: "/pages/500",
    name: "Error-500",
    meta: { authRequired: true },
    component: () => import("./views/utility/500"),
  },
  {
    path: "/paymentRequest",
    name: "PaymentRequest",
    component: () => import("../components/shared/virtual-pos/3DPaymentSuccessfulFB.vue"),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.RoleGroupId === '1') {
        next();
      } else {
        next('/404');
      }
    },
  },
  {
    path: "/project",
    name: "Project",
    component: () => import("../pages/views/project/Project.vue"),
    beforeEnter: (to, from, next) => {
      if (store.state.settings.erpSettings.cartProjectProcess) {
        next();
      } else {
        next('/404');
      }
    },
  },
  {
    path: "/current-visit/:code",
    name: "CurrentVisit",
    component: () => import("../pages/views/current/visit/CurrentVisitList.vue"),
  }
];